import { createContext } from "react"

export const AppStateContext = createContext(null)

export default AppStateContext
